import { isEqual } from 'lodash'

export function replaceItemAtIndex<T>(arr: T[], index: number, newValue: T): T[] {
    return [...arr.slice(0, index), newValue, ...arr.slice(index + 1)]
}

export const getCommonStringsOfArrays = (firstArray: string[], secondArray: string[]): string[] => {
    return firstArray.filter((element) => secondArray.includes(element))
}

export const isEqualArraysByIds = <T extends object>(
    arrayA: T[],
    arrayB: T[],
    idGetter: (item: T, index: number) => string
): boolean => {
    if (arrayA.length !== arrayB.length) return false

    const idsA = arrayA.map((item, idx) => idGetter(item, idx))
    const idsB = arrayB.map((item, idx) => idGetter(item, idx))

    return isEqual(idsA.sort(), idsB.sort())
}

export function safeExtractIds<T extends { id: string }>(items: T[] | undefined): string[] {
    if (!items || !Array.isArray(items)) return []
    return [...new Set(items.map((item) => item.id).filter(Boolean))]
}
